import "@/App.css";
import Header from "@/components/screensaver/Header";
import ArcReactorCore from "@/components/screensaver/ArcReactorCore";
import DataWidget from "@/components/screensaver/DataWidget";
import FloatingParticles from "@/components/screensaver/FloatingParticles";
import TargetingReticle from "@/components/screensaver/TargetingReticle";
import DPLogo from "@/components/screensaver/DPLogo";
import AudioController from "@/components/screensaver/AudioController";
import BrandingOverlay from "@/components/screensaver/BrandingOverlay";
import StockTicker from "@/components/screensaver/StockTicker";
import WeatherWidget from "@/components/screensaver/WeatherWidget";
import CalendarWidget from "@/components/screensaver/CalendarWidget";
import FooterBar from "@/components/screensaver/FooterBar";

const BG_IMG =
  "https://static.prod-images.emergentagent.com/jobs/cc691464-078d-4032-b659-09165a55600a/images/17ea17d41f9d10a16b522d9fd156145ec0d97292c55f86dc0134aff738ba53f1.png";

const IRONMAN_PHOTO =
  "https://customer-assets.emergentagent.com/job_alpha-motion-gallery/artifacts/7kw1i1xz_image.png";

function App() {
  return (
    <div
      data-testid="screensaver-root"
      className="w-screen h-screen overflow-hidden bg-jarvis-bg relative flex flex-col"
      style={{
        backgroundImage: `url(${BG_IMG})`,
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Iron Man photo - right side, scales down on smaller screens */}
      <div
        data-testid="ironman-photo"
        className="absolute right-0 bottom-0 z-[5] pointer-events-none h-[50%] sm:h-[60%] md:h-[70%] lg:h-[75%] xl:h-[88%]"
        style={{ width: "auto" }}
      >
        <img
          src={IRONMAN_PHOTO}
          alt=""
          className="h-full w-auto object-contain object-bottom"
          style={{
            mixBlendMode: "lighten",
            maskImage: "linear-gradient(to top, black 40%, transparent 95%), linear-gradient(to left, black 40%, transparent 95%)",
            WebkitMaskImage: "linear-gradient(to top, black 40%, transparent 95%), linear-gradient(to left, black 40%, transparent 95%)",
            maskComposite: "intersect",
            WebkitMaskComposite: "source-in",
          }}
        />
      </div>

      {/* D|P Logo on the left */}
      <DPLogo />

      {/* Particles - minimal */}
      <FloatingParticles count={6} />

      {/* Corner brackets */}
      <TargetingReticle />

      {/* Header */}
      <Header />

      {/* Stock ticker ribbon */}
      <StockTicker />

      {/* Main dashboard area */}
      <div
        data-testid="main-dashboard"
        className="flex-1 w-full flex flex-col sm:flex-row items-center justify-center px-2 sm:px-3 md:px-4 lg:px-6 gap-1.5 sm:gap-2 lg:gap-3 z-10 relative overflow-hidden"
      >
        {/* Mobile top row: both panels side by side */}
        <div className="flex sm:hidden w-full gap-1.5 px-1 shrink-0">
          <div className="w-1/2 min-w-0">
            <DataWidget side="left" />
          </div>
          <div className="w-1/2 min-w-0">
            <DataWidget side="right" />
          </div>
        </div>

        {/* Mobile: weather + calendar row */}
        <div className="flex sm:hidden w-full gap-1.5 px-1 shrink-0">
          <div className="w-1/2 min-w-0">
            <WeatherWidget />
          </div>
          <div className="w-1/2 min-w-0">
            <CalendarWidget />
          </div>
        </div>

        {/* Mobile: center reactor */}
        <div className="flex sm:hidden items-center justify-center flex-1 max-w-[200px]">
          <ArcReactorCore />
        </div>

        {/* SM+ horizontal layout: left panel */}
        <div className="hidden sm:flex flex-col gap-1.5 md:gap-2 w-[200px] md:w-[250px] lg:w-[280px] xl:w-[320px] 2xl:w-[360px] shrink-0 max-h-[calc(100vh-110px)] overflow-hidden">
          <DataWidget side="left" />
          <div className="flex gap-1.5 md:gap-2">
            <div className="w-[55%] min-w-0">
              <WeatherWidget />
            </div>
            <div className="w-[45%] min-w-0">
              <CalendarWidget />
            </div>
          </div>
        </div>

        {/* SM+ horizontal: center reactor */}
        <div className="hidden sm:flex items-center justify-center flex-1 max-w-[200px] md:max-w-[280px] lg:max-w-[360px] xl:max-w-[420px]">
          <ArcReactorCore />
        </div>

        {/* SM+ horizontal: right panel */}
        <div className="hidden sm:flex flex-col gap-1.5 md:gap-2 w-[200px] md:w-[250px] lg:w-[280px] xl:w-[320px] shrink-0 z-20">
          <DataWidget side="right" />
        </div>
      </div>

      {/* Audio toggle */}
      <AudioController />

      {/* Personal branding overlays */}
      <BrandingOverlay />

      {/* Footer */}
      <FooterBar />
    </div>
  );
}

export default App;
